import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { BankList, BankListPaged } from '../../models/bank.model';
import { Observable } from 'rxjs';
import { PaginationForm } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class BankService {

  private readonly API = `${environment.api_url}/banco`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<BankList[]> {
    return this.http.get<BankList[]>(this.API);
  }

  save(bankBody: BankList): Observable<void> {
    return this.http.post<void>(this.API, bankBody);
  }

  update(bankBody: BankList): Observable<void> {
    return this.http.put<void>(`${this.API}/${bankBody.id}`, bankBody);
  }

  getBankById(id: string): Observable<BankList> {
    return this.http.get<BankList>(`${this.API}/id/${id}`);
  }

  deleteBank(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API}/${id}`);
  }

  getAllPaged(pagination: Partial<PaginationForm>): Observable<BankListPaged> {
    return this.http.get<BankListPaged>(`${this.API}/getByNomeFilter`, {
      params: pagination,
    });
  }
}